import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext } from 'react';
import { Drawer, SwipeableDrawer } from '@mui/material';
import { noop } from 'ts-essentials';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { LeftMenu } from './menu';
import { WindowContext } from 'console/shared/contexts/window/types';
const drawer_width = 280;
const horizontal_mobile_drawer_width = 400;
const paper_props = (opened) => ({
    sx: {
        width: opened ? drawer_width : 0,
        bgcolor: 'additional.main',
        flexShrink: 0,
    },
});
const sx = (opened) => ({
    width: opened ? drawer_width : 0,
    zIndex: 10,
    transition: 'width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
});
const mobile_paper_props = (is_horizontal_mobile) => ({
    sx: {
        width: is_horizontal_mobile ? horizontal_mobile_drawer_width : drawer_width,
        bgcolor: 'background.default',
    },
});
const mobile_sx = {
    zIndex: 250,
};
const swiper_area_props = {
    sx: {
        height: '90%',
        top: 'auto',
    },
};
const ModalProps = { keepMounted: true };
export const LeftMenuContainer = memo(function LeftMenuContainer(props) {
    const { opened, open, close } = props;
    const { is_horizontal_mobile } = useContext(WindowContext);
    return (_jsx(ErrorBoundary, { children: isMediumUI() ? (_jsx(Drawer, { variant: "persistent", open: opened, anchor: "left", PaperProps: paper_props(opened), sx: sx(opened), children: _jsx(LeftMenu, { closeMenu: noop }) })) : (_jsx(SwipeableDrawer, { open: opened, onOpen: open, onClose: close, ModalProps: ModalProps, PaperProps: mobile_paper_props(is_horizontal_mobile), sx: mobile_sx, disableSwipeToOpen: false, swipeAreaWidth: 25, SwipeAreaProps: swiper_area_props, children: _jsx(LeftMenu, { closeMenu: close }) })) }));
});
